export default "__VITE_ASSET__DQcA4ZQC__"